export default __webpack_public_path__ + "static/media/FastFood.d287339f.jpg";